import { render, staticRenderFns } from "./CRFI.vue?vue&type=template&id=4608364e&scoped=true&"
import script from "./CRFI.vue?vue&type=script&lang=js&"
export * from "./CRFI.vue?vue&type=script&lang=js&"
import style0 from "./CRFI.vue?vue&type=style&index=0&id=4608364e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4608364e",
  null
  
)

export default component.exports